import { IIsiDtoIwsUIEntityInfos, IsiDtoIwsUIEntityInfos } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { MenuItemCode } from "../../Isilog.enums";
import { IsiActionContext } from "../Core/IsiActionContext";

export class IsiActionRedirect {

    constructor() {
    }
    /**
     * reset la valeur de l'action de redirection
     * */
    public reset() {
        uiCore.state.uiActionContextIdForRedirect = null;
        uiCore.state.uiActionIdForRedirect = null;
        uiCore.state.uiActionEntitiesInfoForRedirect = null;
    }

    public setFormCloseAction(trvDataKey: string) {
        let action = MNU_MASTER + MNU_SEP + MenuItemCode.FORM_CLOSE + MNU_SEP + MenuItemCode.FORM_CLOSE;

        if (trvDataKey !== "" && trvDataKey !== null) {
            //ARAN 07/10/2009 [DYSF31016]Si on est sur un treeview, on passe un quatrieme parametre contenant la datakey du noeud clique
            action += MNU_SEP + trvDataKey;
        }
        this.reset();
        uiCore.state.uiActionIdForRedirect = action;
        
    }
    /**
     * Créé l'objet permettant de stocker les informations de l'entitée à traiter
     * @param key
     */
    public createAndGetEntitiesInfos(key: string): IIsiDtoIwsUIEntityInfos{
        const infos = IsiDtoIwsUIEntityInfos.fromJS({});
        uiCore.state.uiActionEntitiesInfoForRedirect = {};
        uiCore.state.uiActionEntitiesInfoForRedirect[key] = infos;
        return infos;
    }
    

    public set(actionContext: IsiActionContext, optionTrv: any) {
        uiCore.state.uiActionContextIdForRedirect = actionContext?.associatedViewContext?.id;
        uiCore.state.uiActionIdForRedirect = actionContext.uiAction.id;
        if (optionTrv?.oIsTrv) {
            uiCore.state.uiActionIdForRedirect += '##' + optionTrv.oCodeItemList + '##' + optionTrv.oTrvDataKey;
        }
    }

    public get() {
        if (uiCore.state.uiActionIdForRedirect) {
            return uiCore.state.uiActionIdForRedirect;
        } else {
            return '';
        }
    }

}